import { useState, useCallback } from 'react';

export const useError = () => {
  const [error, setError] = useState('');

  const clearError = useCallback(() => {
    setError('');
  }, []);

  const handleError = useCallback((err, defaultMessage = 'Une erreur est survenue.') => {
    const errorMessage = err?.response?.data?.detail || err?.message || defaultMessage;
    setError(errorMessage);
    console.error('Error:', err);
  }, []);

  return {
    error,
    setError,
    clearError,
    handleError
  };
};